<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    :title="title"
    :content-class="contentClass"
    @closed="$emit('closed')"
  >
    <div class="LKPublicationsFormdataListModal__wrapper">
      <v-row dense>
        <v-col v-if="showStats" cols="5">
          <LKPublicationsFormdataStatsList
            :loading="statsLoading"
            :list="statsList"
            @select="selectItems"
          />
        </v-col>
        <v-col :cols="showStats ? 7 : 12">
          <LKPublicationsFormdataList
            :id="data.id"
            ref="formList"
            :form_template_id="data.form_template_id"
            :formdata-disabled="data.disabled"
          />
        </v-col>
      </v-row>
    </div>
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer from './LKPublicationsFormdataListModalContainer.vue'
import LKPublicationsFormdataList from './LKPublicationsFormdataList.vue'
import LKPublicationsFormdataStatsList
  from './components/LKPublicationsFormdataStatsList.vue'
import { LkFormdataApi } from '@/api/resources'
import { lkMapper } from '@/store/modules/lk'


export default {
  name: 'LKPublicationsFormdataListModal',
  components: {
    LKPublicationsFormdataListModalContainer,
    LKPublicationsFormdataList,
    LKPublicationsFormdataStatsList,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    publicationId: {
      type: [Number, String],
      default: null,
    },
    data: {
      type: Object,
      required: true,
      validator: (prop) => (
        prop
        && 'id' in prop
        && 'form_template_id' in prop
      ),
    },
  },
  data: () => ({
    statsLoading: false,
    statsList: [],
  }),
  computed: {
    ...lkMapper.mapGetters(['profile']),
    showStats() {
      return this.profile.is_superuser || this.profile.is_federal_level || this.profile.region_id
    },
    contentClass() {
      let baseClass = 'LKPublicationsFormdataListModal'
      if (!this.showStats) baseClass += ' LKPublicationsFormdataListModal_short'
      return baseClass
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
      if (this.showStats) {
        await this.getStatsList()
      }
    },
    close() {
      this.$refs.modal.close()
    },
    selectItems(filters) {
      this.$refs.formList.$refs.filters.setFilters(filters)
    },
    async getStatsList() {
      const api = new LkFormdataApi()
      this.statsLoading = true
      try {
        const isCuratorOfThisPublication = this.publicationId
          && this.profile.publications_curator?.includes(this.publicationId)
        const { data } = this.profile.region_id && !isCuratorOfThisPublication
          ? await api.getMunStats(this.data.id, {
            params: {
              data_collection_id: this.data.id, region_id: this.profile.region_id,
            },
          })
          : await api.getStats(this.data.id, { params: { data_collection_id: this.data.id } })
        this.statsList = data
      } catch (e) {
        this.$notice.errors(e)
      }
      this.statsLoading = false
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataListModal {
  width: 100%;
  max-width: 2000px;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;

  &_short {
    max-width: 1024px;
  }

  &__wrapper {
    height: calc(100% - 52px);

    .row {
      height: 100%;
    }

    .col {
      height: 100%;
    }
  }
}
</style>
